<div class="dropdown-wrapper" [class.is-open]="isOpen">
  @if (label) {
  <label class="dropdown-label" [attr.for]="dropdownId">
    {{ label | translate }}
    @if (required) {
    <span class="required-indicator">*</span>
    }
  </label>
  }

  <div
    class="dd"
    [class.dd--open]="isOpen"
    [class.dd--disabled]="disabled || isLoading"
    [class.dd--error]="hasError"
  >
    <!-- Trigger -->
    <button
      #ddTrigger
      type="button"
      class="dd-trigger"
      [id]="dropdownId"
      [disabled]="disabled || isLoading"
      (click)="toggleDropdown()"
      [attr.aria-label]="label || placeholder"
      [attr.aria-expanded]="isOpen"
      aria-haspopup="listbox"
    >
      <span
        class="dd-trigger__value"
        [class.dd-trigger__value--placeholder]="!selectedValue"
      >
        @if (triggerTemplate && selectedValue) {
        <ng-container
          *ngTemplateOutlet="
            triggerTemplate;
            context: { $implicit: getSelectedOption() }
          "
        ></ng-container>
        } @else {
        {{ selectedLabel | translate }}
        }
      </span>
      <span class="dd-trigger__arrow">
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
          <path
            d="M1 1L5 5L9 1"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>

    <!-- Panel -->
    @if (isOpen && !disabled) {
    <div
      class="dd-panel"
      [class.dd-panel--up]="isDropup"
      (mousedown)="$event.stopPropagation()"
      role="listbox"
    >
      <!-- Arama -->
      @if (searchable) {
      <div class="dd-search" (mousedown)="$event.stopPropagation()">
        <svg
          class="dd-search__icon"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          #searchInput
          type="text"
          class="dd-search__input"
          [value]="searchTerm"
          (input)="onSearchChange($event)"
          (mousedown)="$event.stopPropagation()"
          [placeholder]="searchPlaceholder"
          autocomplete="off"
        />
        @if (searchTerm) {
        <button
          type="button"
          class="dd-search__clear"
          (click)="searchTerm = ''; searchChange.emit('')"
          tabindex="-1"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        }
      </div>
      }

      <!-- Seçenekler -->
      <div class="dd-options">
        <!-- Boş seçenek (Seçiniz) -->
        @if (showSelectOption) {
        <div
          class="dd-option dd-option--reset"
          role="option"
          tabindex="0"
          [class.dd-option--active]="!selectedValue"
          [class.dd-option--focused]="focusedIndex === 0"
          [attr.aria-selected]="!selectedValue"
          (click)="$event.stopPropagation(); selectOption(null)"
          (keyup.enter)="selectOption(null)"
          (keyup.space)="selectOption(null)"
        >
          {{ placeholder | translate }}
        </div>
        }

        <!-- ng-content (dışarıdan eklenen seçenekler) -->
        <ng-content></ng-content>

        @if (isLoading) {
        <!-- Yükleniyor -->
        <div class="dd-option dd-option--info">
          <svg
            class="dd-spinner"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke-dasharray="32"
              stroke-dashoffset="32"
            />
          </svg>
          {{ loadingText | translate }}
        </div>
        } @else { @if (filteredOptions.length === 0) {
        <!-- Sonuç yok -->
        <div class="dd-option dd-option--empty">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
            <line x1="8" y1="11" x2="14" y2="11" />
          </svg>
          {{ noResultsText | translate }}
        </div>
        } @else { @for (option of filteredOptions; track option.value; let i =
        $index) {
        <!-- Normal seçenek -->
        <div
          class="dd-option"
          role="option"
          tabindex="0"
          [class.dd-option--active]="option.value === selectedValue"
          [class.dd-option--focused]="
            showSelectOption ? i + 1 === focusedIndex : i === focusedIndex
          "
          [class.dd-option--disabled]="option.disabled"
          [attr.aria-selected]="option.value === selectedValue"
          (click)="$event.stopPropagation(); selectOption(option)"
          (keyup.enter)="selectOption(option)"
          (keyup.space)="selectOption(option)"
        >
          @if (optionTemplate) {
          <ng-container
            *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"
          ></ng-container>
          } @else {
          <span class="dd-option__label">{{ option.label | translate }}</span>
          } @if (option.value === selectedValue) {
          <svg
            class="dd-option__check"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
          }
        </div>
        } } }
      </div>
    </div>
    }
  </div>

  @if (hint && !hasError) {
  <span class="dropdown-hint">{{ hint }}</span>
  } @if (hasError) {
  <span class="dropdown-error" role="alert">{{ errorText | translate }}</span>
  }
</div>
